import request from '@/utils/request'

const accounts = '/Sites.SiteAuthorization'

/**
 * 修改 SYS 用户密码接口
 * @param data 数据
 */
export const changePassword = (data: any) => {
  return request({
    method: 'POST',
    url: `${accounts}/User/ChangePassword`,
    data
  })
}

// *******************找回密码*******************
/**
 * 校验员工信息
 * @param employeeCode 工号
 */
export const getUserValidateType = (employeeCode: string) => {
  return (request as any)({
    method: 'GET',
    url: `${accounts}/RetrievePassword/GetUserValidateType`,
    params: {
      employeeCode
    },
    isNotMessage: true,
    isNotAuth: true
  })
}

/**
 * 发送验证码
 * @param EmployeeCode 工号
 * @param Type 类型 Email 邮箱
 */
export const sendCaptcha = (EmployeeCode: string, Type: string) => {
  return (request as any)({
    method: 'POST',
    url: `${accounts}/RetrievePassword/SendCaptcha`,
    data: {
      EmployeeCode,
      Type
    },
    isNotAuth: true
  })
}

/**
 * 校验验证码
 * @param EmployeeCode 员工
 * @param Captcha 验证
 */
export const verifyCaptcha = (EmployeeCode: string, Captcha: string) => {
  return (request as any)({
    method: 'POST',
    url: `${accounts}/RetrievePassword/VerifyCaptcha`,
    data: {
      EmployeeCode,
      Captcha
    },
    isNotMessage: true,
    isNotAuth: true
  })
}

/**
 * 重置密码
 * @param data Token 验证码返回的token/NewPassword 新密码/EmployeeCode 工号
 */
export const resetPassword = (data: any) => {
  return (request as any)({
    method: 'POST',
    url: `${accounts}/RetrievePassword/ChangePassword`,
    data: {
      ...data
    },
    isNotAuth: true
  })
}
